import React from 'react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const reviews = [{
    src: 'https://cdn.magicpatterns.com/uploads/i4o8k3mmPxie696np8MVrZ/4.png',
    alt: 'Reseña de una aventurera',
    rotation: -3
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/uUDJBHzEFkf4P9hSQaXUjw/5.png',
    alt: 'Reseña de una aventurera con corazón',
    rotation: 2
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/aeDobqzwx9wsXPfhL1vmB6/6.png',
    alt: 'Reseña de una aventurera',
    rotation: -2
  }];
  return <section className="relative py-16 md:py-20 px-6 md:px-12 lg:px-24 overflow-hidden" data-id="element-164">
      {/* Background landscape image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/wJYGJLQjXxSprjgqx1K4sA/Copia_de_Salar_de_uyuni_(2660_x_1140_px).png")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-165">
        <div className="absolute inset-0 bg-charcoal/60" data-id="element-166" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto w-full" data-id="element-167">
        {/* Eyebrow & heading */}
        <div className="mb-10 md:mb-12 text-center" data-id="element-168">
          <span className="text-xs font-sans uppercase tracking-[0.3em] text-white/70 block mb-3" data-id="element-169">
            — 03 / TESTIMONIOS
          </span>
          <div className="w-20 h-[1px] bg-white/30 mx-auto mb-6" data-id="element-170" />

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} className="text-3xl md:text-4xl lg:text-5xl font-serif italic text-white leading-[1.1]" data-id="element-171">
            Lo que viven
            <br data-id="element-172" />
            nuestras <span className="font-bold" data-id="element-173">Aventureras</span>
          </motion.h2>
        </div>

        {/* Reviews grid — playfully tilted, straighten on hover */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-center" data-id="element-174">
          {reviews.map((review, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20,
          rotate: review.rotation
        }} whileInView={{
          opacity: 1,
          y: 0,
          rotate: review.rotation
        }} whileHover={{
          rotate: 0,
          scale: 1.03
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: idx * 0.12,
          ease: 'easeOut'
        }} className="flex items-center justify-center cursor-pointer" data-id="element-175">
              <img src={review.src} alt={review.alt} className="w-full h-auto object-contain rounded-2xl drop-shadow-2xl" data-id="element-176" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}